module.exports = __webpack_public_path__ + "img/pro_s2_icon5.22fb70fa.png";